import { Linkedin } from "lucide-react";

const initials = (name) => name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const AuthorBadge = ({ author, className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} data-testid="author-badge">
    <div
      className="w-12 h-12 shrink-0 bg-[#FACC15] text-black flex items-center justify-center font-bold text-base"
      style={{ fontFamily: "'Outfit', sans-serif" }}
      aria-hidden="true"
    >
      {initials(author.name)}
    </div>
    <div className="min-w-0">
      <p className="text-white text-sm font-semibold leading-tight" data-testid="author-name">{author.name}</p>
      <p className="text-white/55 text-xs mt-0.5" data-testid="author-role">{author.role}</p>
    </div>
    <a
      href={author.linkedin}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`LinkedIn di ${author.name}`}
      className="ml-auto w-9 h-9 border border-[#262626] flex items-center justify-center text-white/60 hover:text-[#FACC15] hover:border-[#FACC15] transition-colors"
      data-testid="author-linkedin"
    >
      <Linkedin size={16} />
    </a>
  </div>
);

export default AuthorBadge;
